import { TotalProduction } from "../../../../shared/interfaces/services/total-production";
import { formattedPrice } from "../../../../shared/utils";
import { parseCurrencyValue } from "../../../../shared/utils/parseCurrencyValue";
import { TotalProductionCard } from "../components/TotalProductionCard";
const renderCurrency = (value: string) => {
      return `$ ${formattedPrice(value.toString())}`
}
export const mapOfTotalProduction = (totalsProduction: Array<TotalProduction> = []) => totalsProduction.map(({
    rama,
    mes,
    anio,
    primaEmitida,
    premioEmitido,
    comisionEmitida,
    primaCobrada,
    premioCobrado,
    comisionCobrada

}) => ({
    'Rama': rama ?? '',
    'Mes': mes ?? '',
    'Año': anio  ?? '',
    'Prima Emi.': parseCurrencyValue(primaEmitida) ?? '',
    'Premio Emi.': parseCurrencyValue(premioEmitido) ?? '',
    'Comision Emi.': parseCurrencyValue(comisionEmitida) ?? '',
    'Prima Cob.': parseCurrencyValue(primaCobrada) ?? '',
    'Premio Cob.': parseCurrencyValue(premioCobrado) ?? '',
    'Comision Cob.': parseCurrencyValue(comisionCobrada) ?? '',
}));